















































import { Component, InjectReactive, Vue } from 'vue-property-decorator';

import { FeedProduct } from '../../../models';
import { FeedTank, ProductType } from '@/api';
import { Constants } from '@/common/Constants';

import ManageEventSubscriptions from '@/components/manage-event-subscriptions.vue';
import EventSubscriptionsList from '@/components/tables/event-subscriptions.vue';
import DeletedEventSubscriptionAudits from '@/components/tables/deletedEventSubscriptionAudits.vue';
import NotificationsSentList from '@/components/tables/notifications.vue';
import EventSubscriptionChangeLog from '@/components/tables/event-subscription-change-log.vue';

@Component({
	components: {
		ManageEventSubscriptions,
		EventSubscriptionsList,
		DeletedEventSubscriptionAudits,
		NotificationsSentList,
		EventSubscriptionChangeLog,
	},
})
export default class FeedTankAlertsSection extends Vue {
	@InjectReactive('feedProduct')
	public feedProduct!: FeedProduct;

	@InjectReactive('selectedFeedTank')
	public feedTank!: FeedTank;

	public productType = ProductType.Feed;
	public entityType = Constants.ENTITY_TYPE_FEED_TANK;
}
